module.exports = __webpack_public_path__ + "static/media/2.064e829f.JPG";